module.exports = __webpack_public_path__ + "static/media/Haiti.156d97d7.png";